import React from 'react';
import Swiper from 'react-id-swiper';
import $ from 'jquery';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Landing from '../../views/common/Landing';
import HmEventRegistry from '../../model/HmEventRegistry';

import HmAjax from '../../util/HmAjax';
import { Table, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import '../../css/scorecard.css';
//import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
//Import React Table
import recommend from '../../images/icons/hey_icon.png';

import scardpicon from '../../images/icons/scardp_icon.png';
import scardgicon from '../../images/icons/scardg_icon.png';
import recomLessonIcon from '../../images/icons/recom_lesson.png';
import recomPracticeIcon from '../../images/icons/recom_practice.png';
import recomRelatedLessonIcon from '../../images/icons/recom_related_lesson.png';
import LessonComponent from './LessonComponent';
import ViewSolution from './ViewSolution';

import Loader from 'react-loader-spinner';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import '../../views/plp/TestInfo';
import '../../vendors/mindstretcher/ms_TestInfo';

import GetTest from '../../views/plp/GetTest';

import PiechartComp from './Piechart';
import Imageslider from './Imageslider';
import Navtop from '../../views/common/Navtop';

import ratingDefaultIcon from '../../images/icons/emojis/rating_default.png';

import ratingBadIcon from '../../images/icons/emojis/bad.gif';
import ratingGoodIcon from '../../images/icons/emojis/good.gif';
import ratingLoveitIcon from '../../images/icons/emojis/loveit.gif';
import ratingNormalIcon from '../../images/icons/emojis/normal.gif';
import ratingVerybadIcon from '../../images/icons/emojis/verybad.gif';

import ratingBadIconSmall from '../../images/icons/emojis/bad_small.png';
import ratingGoodIconSmall from '../../images/icons/emojis/good_small.png';
import ratingLoveitIconSmall from '../../images/icons/emojis/loveit_small.png';
import ratingNormalIconSmall from '../../images/icons/emojis/normal_small.png';
import ratingVerybadIconSmall from '../../images/icons/emojis/verybad_small.png';

//import image1 from '../../images/recommand/image1.jpg'; 

var settings = {
	dots: false,
	infinite: false,
	speed: 300,
	slidesToShow: 5,
	slidesToScroll: 5,
	responsive: [
	{
		breakpoint: 1370,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 4,
			infinite: false,
			dots: false
		}
	},
	{
		breakpoint: 1100,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: false,
			dots: false
		}
	},
	{
		breakpoint: 767,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		}
	},
	{
		breakpoint: 550,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		}
	}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
		]
	};

	var scorecardLoadedTime = null;
	export default class Scorecard extends Landing {
		constructor(props) {
			super(props);
			this.scoreCalculated = false;

			this.testId = 0;
			this.state = { 
				dataLoaded: false, 
				data: {}, 
				testModalView: "", 
				testModalShow: false, 
				testModalContent: "loading", 
				modalTitle: "", 
				piechartdata: false, 
				existingRatingObj: {},
				popoverOpen: false,				
				selectedEmoji: null,
				hideRatingModal:false,
				classDefnMap:null,
				recomLocked:{
					similarProblemLocked:false,
					recommendedLessonLocked:false,
					practiceLocked:false}
				};
				
				this.questionTypeCount = 0;
				this.questionCount = 0;
				this.attemptCount = 0;
				this.unAttemptedCount = 0;
				this.partialCorrect = 0;
				this.questionsCorrect = 0;
				this.questionsIncorrect = 0;
				this.totalScore = 0;
				this.userScore = 0;
				this.testMode = 0;

				this.questions = [];
				this.recommdata = {};
				this.userGrade = 0;
				this.totalPoints = 0;
				this.userPoints = "";

				this.showRecommendationScreen = this.showRecommendationScreen.bind(this);
				this.showTestModal = this.showTestModal.bind(this);
				this.hideTestModal = this.hideTestModal.bind(this);
				this.hideRatingModal = this.hideRatingModal.bind(this);
				this.startTest = this.startTest.bind(this);
				this.setModalBackdropClose = this.setModalBackdropClose.bind(this);
				this.feedbackText = "";
				this.feedbackText2 = "";
				this.noLessonMode = false;
				this.currentScrollIndex=1;
				this.selectedRate = null;
				this.toggle = this.toggle.bind(this);
				this.selectRating = this.selectRating.bind(this);
				this.handleMouseOver = this.handleMouseOver.bind(this);
				this.handleMouseOut = this.handleMouseOut.bind(this);	
				this.isFreeTrail = this.isFreeTrail.bind(this);	
				this.isFreeTrailSub = this.isFreeTrailSub.bind(this);	
				this.isPurchased = this.isPurchased.bind(this)

				this.ga = {"subscribe-btn":""};
			}
			
			addGa(){
				this.ga['subscribe-btn'] = this.ViewsolutionGA();
				return this.ga;
			}

			lscrFn(e) {
				console.log("left")
				const scrdiv = document.querySelector('.imgGal');
			}

			rscrFn(e) {
				console.log("right")
				const scrdiv = document.querySelector('.imgGal');
			}

			handleMouseOver(event){	
				$(event.currentTarget).find(".hovertxt").show();
			}

			handleMouseOut(event){
				$(".hovertxt").hide();
			}
			
			getAllSolutionsTrackingDetails() {

				var trackingParams = [];
				if (this.questions.length > 0) {
					for (var i = 0; i < this.questions.length; i++) {
						var quesObj = {};
						quesObj["questionId"] = this.questions[i].testQuestionId;
						quesObj["snippetId"] = this.questions[i].snippetId;
						quesObj["currQuestAtt"] = this.questions[i].attemptNo;
						trackingParams.push(quesObj);
					}
				}
		//console.log("trackingParams",trackingParams);
		var me = this;
		var callBackSuccess = function (response) {
			me.setState({ existingRatingObj: response });
			//console.log("GET_TRACKING_DETAILS response",response);
		}

		var callBackFailure = function (error) {
			console.log("Error in Scorecard GET_TRACKING_DETAILS");
		}

		new HmAjax(this.getUrlFor("GET_TRACKING_DETAILS") + this.testId, trackingParams).post(callBackSuccess, callBackFailure);


	}
	showViewSolutionScreen() {
		this.currentScrollIndex=1; 
		this.setState({ testModalShow: true, testModalContent: this.renderViewSolution(), modalTitle: this.setQModalTitle(this.state.data), testModalView: "staticContent", modalLabel: "View Solutions"});
	}
	showRecommendationScreen() {
		this.setState({ testModalShow: true, testModalContent: this.renderRecomendationContent(), modalTitle: this.state.data.testDetails.topics, testModalView: "staticContent", modalLabel: "View Recommendations"});		
	}

	renderViewSolution() {
		this.trackRecommendationSolutionLoaded("solutions");
		//console.log("this.testId="+this.testId+", subtopicid="+this.state.data.testDetails.topicSubTopicMapId);
		var me = this;
		//Decide whether to show the View Solution button or not
		let isSolutionAvailable = this.state.data.isSolutionAvailable;
		let solutionDate = this.state.data.solutionDate;

		if(isSolutionAvailable){
			return (
				<ViewSolution questionTypeCount={this.questionTypeCount} ga={me.addGa()} questions={this.questions} testId={me.testId} topicSubTopicMapId={me.state.data.testDetails.topicSubTopicMapId} existingRatingObj={me.state.existingRatingObj} accessId={me.state.data.testDetails.accessId} classId={me.state.data.testDetails.classId}  recomLocked={me.state.recomLocked}/>			
				);
			
		}else{
			return (
				<div>
				{(() => {
					if(solutionDate){
						return me.rb("scorecard.label.solutionAvailableOn",[solutionDate])
					}else{
						return me.rb("scorecard.label.solutionNotAvailable");
					}
				})()}
				</div>
				);
			}
		}	
		showRatingPopup() {
			if (this.state.dataLoaded) {
				//console.log("rating popup:::",this.state.data.testDetails);
				var completedOn = this.state.data.completedOnInSeconds;
				var currentTime = this.getUnixTime();
			//console.log("completedOn:::",completedOn);
			//console.log("currentTime:::",currentTime);
			var diffInSeconds = (currentTime - completedOn);
			//console.log("diffInSeconds="+diffInSeconds);
			// if(this.state.data.testDetails.mode != 1 && diffInSeconds <= 30){

				var showRatingDelayTime = window.showRatingDelayTime || 5;
				if(diffInSeconds <= showRatingDelayTime){
					this.setState({ ratingModalShow: true});
				}
			}
		}
		getUnixTime(){
			return new Date(new Date().toUTCString()).getTime()/1000
		}
		componentDidUpdate(){
			if(this.props.match.params.reset){
				$(".content-inner").css("width","100%");
			}
		}
		componentDidMount() {
			console.log("reset:::"+this.props.match.params.reset);
			this.setState({ loggedIn: true, piechartdata: true });
			this.getScorecardData();
			this.getClassNames();
			HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
			this.fireMobileToast();
		}

		getClassNames(callBack){
			var me = this;
			var callBackSuccess = function(response){
				me.setState({classDefnMap:response.classDefn});
			}

			var callBackFailure = function(error){			
			}

			new HmAjax(this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);	
		}

		getScorecardData() {
			try {
				var me = this;

				var successHandler = function (data) {
					if ((data === null) || (data !== null && data.error)) {
						var buttons = [{
							label: me.rb("go_home"),
							handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
						}]
						me.showAlert(me.rb(data.testStatus), me.rb(data.reference_id) || me.rb(data.testStatus), buttons);

						return;
					}

					try {
						var accessMap = me.getUser().getAccessMap();
						me.noLessonMode = (accessMap[data.testDetails.accessId] === "PLP|TEST|TAKE");
					} catch (e) { }

				// me.setState({recomLocked:{
				// 	similarProblemLocked:data.similarProblemLocked,
				// 	recommendedLessonLocked:data.recommendedLessonLocked,
				// 	practiceLocked:data.practiceLocked
				// }});

				me.calculatePointsAndGrade(data);
				var rating = data.rating ? parseInt(data.rating) : 0;
				me.setState({ dataLoaded: true, "data": data, selectedEmoji: rating ,recomLocked:{
					similarProblemLocked:data.similarProblemLocked,
					recommendedLessonLocked:data.recommendedLessonLocked,
					practiceLocked:data.practiceLocked
				}});

				console.log("isFreeTrail1",me.state.recomLocked.recommendedLessonLocked);
				me.selectedRate = rating;
				me.trackScorecardLoaded();
				me.getAllSolutionsTrackingDetails();
				me.showRatingPopup();
				me.render();
			}

			var failureHandler = function (err) {
				var buttons = [{
					label: me.rb("go_home"),
					handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
				}]
				me.showAlert(me.rb("error"), me.rb("generic_connect_error"), buttons);

				return;
			}

			this.testId = this.props.match.params.id;
			let versionSuffix = this.props.match.params.reset && !isNaN(this.props.match.params.reset) ? ("/"+this.props.match.params.reset)  : "";
			//new HmAjax(this.getUrlFor("SCORECARD_DATA")).get(successHandler, failureHandler);
			new HmAjax(this.getUrlFor("SCORECARD_DATA") + this.testId +versionSuffix).get(successHandler, failureHandler);
		} catch (e) {
			var buttons = [{
				label: me.rb("go_home"),
				handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
			}]
			me.showAlert(me.rb("error"), me.rb("system_error"), buttons);
		}


		if (scorecardLoadedTime == null) {
			scorecardLoadedTime = new Date().getTime();
		}
	}
	
	getFeedBackText() {
		return this.feedbackText;
	}

	getFeedBackText2() {
		return this.feedbackText2;
	}

	getOriginalFeedBackText(gradeDtls) {
		if (gradeDtls.oldPercent === 100) {
			return this.rb("scorecard.test.grade-full-A+");
		} else {
			return this.noLessonMode ? this.rb("scorecard.test.nolesson-grade-" + ((gradeDtls.oldGrade && gradeDtls.oldGrade.length > 0) ? gradeDtls.oldGrade : "C")) : this.rb("scorecard.test.grade-" + ((gradeDtls.oldGrade && gradeDtls.oldGrade.length > 0) ? gradeDtls.oldGrade : "C"));
		}
	}

	getUpdatedFeedBackText(gradeDtls) {
		if (gradeDtls.newPercent === 100) {
			return this.rb("scorecard.practice.grade-full");
		} else if (gradeDtls.gradeChanged) {
			return this.rb("scorecard.practice.grade-change").replace("{1}", gradeDtls.oldGrade).replace("{2}", gradeDtls.newGrade);
		} else if (gradeDtls.percentChanged) {
			return this.rb("scorecard.practice.grade-nochange").replace("{1}", gradeDtls.oldPoints).replace("{2}", gradeDtls.newPoints);
		} else {
			return this.rb("scorecard.practice.point-nochange");
		}
	}

	getRecommendedViewFeedBackForPractice(gradeDtls) {
		if (gradeDtls.newPercent === 100) {
			return this.rb("scorecard.practice.grade-full");
		} else if (gradeDtls.gradeChanged) {
			return this.rb("scorecard.practice.grade-change").replace("{1}", gradeDtls.oldGrade).replace("{2}", gradeDtls.newGrade);
		} else if (gradeDtls.percentChanged) {
			return this.rb("scorecard.practice.grade-nochange").replace("{1}", gradeDtls.oldPoints).replace("{2}", gradeDtls.newPoints);
		} else if (gradeDtls.newPercent === 0) {
			return this.rb("scorecard.recommended.rawtext1");
		} else {
			return this.rb("scorecard.practice.point-nochange");
		}
	}

	processFeedBackText() {
		if (this.state.data && this.state.data.topicGradeDtls) {
			try {
				var gradeDtls = Object.values(Object.values(this.state.data.topicGradeDtls)[0])[0];
				if (gradeDtls) {
					//this one is for Test - to show the original comment
					if (this.state.data.isActualTest) {
						this.feedbackText = this.getOriginalFeedBackText(gradeDtls);
						this.feedbackText2 = this.getRecommendedViewFeedBackForPractice(gradeDtls);
					} else {
						// This one is for practice - to show the new comment
						this.feedbackText = this.getUpdatedFeedBackText(gradeDtls);
					}
				}
			} catch (e) {
				console.error(e);
			}
		}
	}

	calculateQuestionCount() {
		if (!this.scoreCalculated) {
			this.testMode = this.state.data.testDetails.mode;
			if (this.testMode === 1) {
				this.calculateScoreForTest();
			} else if (this.testMode === 2) {
				this.calculateScoreForStandard();
			} else if (this.testMode === 3) {
				this.calculateScoreForAdaptive();
			}

			this.scoreCalculated = true;
		}
	}

	calculateScoreForTest() {
		var me = this;
		try {
			this.state.data.transcripts.map((transcript, index) => {
				try {
					me.questionTypeCount++;
					if (transcript.attempts === null || transcript.attempts.length <= 0) {
						me.unAttemptedCount++;
						me.questionCount++;
					} else {
						transcript.attempts.map((attempt, index) => {
							//Push additional details to attempt object 
							attempt.questionNo = transcript.questionNo;
							attempt.testMode = "TEST";

							//This method pushes the question to renderer array
							me.populateQuestions(attempt);

							me.totalScore += attempt.marks;

							me.questionCount++;
							if (attempt.attempted) {
								me.attemptCount++;
								if (attempt.attemptCorrect) {
									me.questionsCorrect++;
								} else if (attempt.partialCorrect) {
									me.partialCorrect++;
								} else {
									me.questionsIncorrect++;
								}
							} else {
								me.unAttemptedCount++;
							}

							me.userScore += attempt.userMarks;
						})
					}
					// For Test, take the user marks
					//me.userScore = me.state.data.testDetails.marks;
				} catch (e) {
					console.log("Error occurred for the question of index:" + index, e);
				}

			})

		} catch (e) {
			console.error("Error occurred while calculating questions count in Scorecard:", e);
		}
	}

	calculateScoreForAdaptive() {
		var me = this;
		try {
			this.state.data.transcripts.map((transcript, index) => {
				try {
					me.questionTypeCount++;
					me.questionCount++;
					if (transcript.attempts === null || transcript.attempts.length <= 0) {
						me.unAttemptedCount++;
					} else {
						me.totalScore++;

						if (transcript.answerCorrect) {
							me.userScore++;
							me.questionsCorrect++;
						} else {
							me.questionsIncorrect++;
						}

						transcript.attempts.map((attempt, index) => {
							//Push additional details to attempt object 
							attempt.questionNo = transcript.questionNo;
							attempt.testMode = "PRACTICE";

							//This method pushes the question to renderer array
							me.populateQuestions(attempt);
						})
					}
				} catch (e) {
					console.log("Error occurred for the question of index:" + index, e);
				}

			})

		} catch (e) {
			console.error("Error occurred while calculating questions count in Scorecard:", e);
		}
	}

	calculateScoreForStandard() {
		var me = this;
		try {
			this.state.data.transcripts.map((transcript, index) => {
				try {
					me.questionTypeCount++;
					if (transcript.attempts === null || transcript.attempts.length <= 0) {
						me.unAttemptedCount++;
					} else {
						transcript.attempts.map((attempt, index) => {
							//Push additional details to attempt object 
							attempt.questionNo = transcript.questionNo;
							attempt.testMode = "TEST";

							//This method pushes the question to renderer array
							me.populateQuestions(attempt);

							me.totalScore++;
							if (attempt.attemptCorrect) {
								me.userScore++;
							}

							me.questionCount++;
							if (attempt.attempted) {
								me.attemptCount++;
								if (attempt.attemptCorrect) {
									me.questionsCorrect++;
								} else if (attempt.partialCorrect) {
									me.partialCorrect++;
								} else {
									me.questionsIncorrect++;
								}
							} else {
								me.unAttemptedCount++;
							}
						})
					}
				} catch (e) {
					console.log("Error occurred for the question of index:" + index, e);
				}

			})

		} catch (e) {
			console.error("Error occurred while calculating questions count in Scorecard:", e);
		}
	}

	populateQuestions(questionAttempt) {
		try {
			this.questions.push(questionAttempt);
		} catch (e) {
			console.log("Error Occurred while populating questions.", e);
		}
	}

	calculatePointsAndGrade(data) {
		try {
			this.userPoints = data.userPoints || 0;
			this.totalPoints = data.testPoints || 0;
			this.userGrade = data.grade;
		} catch (e) { }

	}

	getUserPoints() {
		return this.userPoints;
	}

	getTotalPoints() {
		return this.totalPoints;
	}

	getUserGrade() {
		return this.userGrade;
	};

	getTotalScore() {
		return this.totalScore;
	}

	getQuestionCount() {
		return this.questionCount;
	}

	getAttemptedCount() {
		return this.attemptCount;
	}

	getUnAttemptedCount() {
		return this.unAttemptedCount;
	}

	getCorrectCount() {
		return this.questionsCorrect;
	}

	getIncorrectCount() {
		return this.questionsIncorrect;

	}

	unanswerdata(topicInfoObj) {
		if (topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1") {
			return (
				<tr>
				<td className="nosidepaddingmust"><span><i className="material-icons resultalg noans">fiber_manual_record</i></span><span className="boxtxt">{this.rb("scorecard.unanswered")}</span></td>
				<td className="nosidepaddingmust">{this.getUnAttemptedCount()}</td>
				</tr>)
		}
	}

	getPartialCorrectCount() {
		return this.partialCorrect;
	}

	getSummaryPointColumn(transcript) {
		var attPoints = 0;
		try {
			if (this.testMode === 1) {
				transcript.attempts.map((attempt, index) => {
					attPoints += attempt.attemptPoints;
				})
			} else if (this.testMode === 2) {
				transcript.attempts.map((attempt, index) => {
					if (attempt.attemptCorrect) {
						attPoints += attempt.attemptPoints;
						//attPoints++;
					}
				})
			} else if (this.testMode === 3) {
				transcript.attempts.map((attempt, index) => {
					if (attempt.attemptCorrect) {
						attPoints += attempt.attemptPoints;
						//attPoints++;
					}
				})
			}
		} catch (e) { }

		return attPoints;
	}

	getSummaryMarkColumn(transcript) {
		var attMark = 0;
		try {
			if (this.testMode === 1) {
				transcript.attempts.map((attempt, index) => {
					attMark += attempt.userMarks;
				})
			} else if (this.testMode === 2) {
				transcript.attempts.map((attempt, index) => {
					if (attempt.attemptCorrect) {
						attMark++;
					}
				})
			} else if (this.testMode === 3) {
				transcript.attempts.map((attempt, index) => {
					if (attempt.attemptCorrect) {
						attMark++;
					}
				})
			}
		} catch (e) { }

		return attMark;
	}

	getSummaryOutcomesColumn(transcript) {
		try {
			return (
				<div>
				<div className="resultspan">
				{transcript.attempts.map((attempt, index) => {
					if (attempt.attemptCorrect) {
						return <span key={index}><i className="material-icons resultalg rightans">done</i></span>;
					} else if (attempt.attempted) {
						return <span key={index}><i className="material-icons resultalg wrongans">close</i></span>;
					} else {
						return <span key={index}><i className="material-icons resultalg noans">fiber_manual_record</i></span>;
					}
				}
				)}
				</div>
				</div>
				)

		} catch (e) { }
	}

	getSummaryView() {
		return (
			<div>
			<Table className="result1">
			<thead>
			<tr className="resulthead">
			<th>{this.rb("scorecard.question_col")}</th>
			<th>{this.rb("scorecard.result_col")}</th>
			<th>{this.rb("scorecard.points_col")}</th></tr>
			</thead>

			<tbody>
			{this.state.data.transcripts.map((transcript, index) => {
				return <tr key={index}>
				<td className="qorder">{transcript.questionNo}</td>
				<td>{this.getSummaryOutcomesColumn(transcript)}</td>
				<td>{this.getSummaryPointColumn(transcript)}</td>
				</tr>

			})}
			</tbody>
			</Table>

			</div>
			)
	}

	ViewsolutionGA(){
		return "Post login - "+this.state.classDefnMap[this.state.data.testDetails.classId].className+" - Tests - "+this.state.data.breadcrumb.topicname+" - "+this.state.data.breadcrumb.subtopicname+" - "+(this.state.data.testDetails.mode == 1 ? "PT" : "CP")+" - "+"Scorecard - View Solutions";
	}

	ViewRecommendationGA(){
		return "Post login - "+this.state.classDefnMap[this.state.data.testDetails.classId].className+" - Tests - "+this.state.data.breadcrumb.topicname+" - "+this.state.data.breadcrumb.subtopicname+" - "+(this.state.data.testDetails.mode == 1 ? "PT" : "CP")+" - "+"Scorecard - View Recommendations";
	}

	getRecommendViewOnTop() {
		var recomStr = this.state.data.recommendResponseStr;
		let me = this;

		var recommendations = {};
		let isSolutionAvailable = this.state.data.isSolutionAvailable;
		let recommendedBtnStyleClass = "col-sm-12 col-md-6 col-12 text-center";

		if(!isSolutionAvailable){
			recommendedBtnStyleClass = "col-12 text-center";
		}

		try {
			if (recomStr !== undefined && recomStr !== null && recomStr !== "null") {
				recommendations = JSON.parse(recomStr).recommendResponse;
				this.recommdata = recommendations;
				this.processRelatedLessons();
				if (typeof recommendations === "object" && Object.keys(recommendations).length > 0) {
					if(me.props.match.params.reset){
						if (me.recommdata.testDetails) {
							return(
								<div className="clearfix col-12 row topbtnscontainer">
								{(() =>{
									if(isSolutionAvailable){
										return (<div className="col-sm-12 col-md-6 col-12 text-center borderight">	
											<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln widthmax no-float" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.review_solution")}</button>		
											</div>);
									}else{
										return (<div></div>);
									}
								})()}								
								<div className={recommendedBtnStyleClass}>
								<button type="button" onClick={me.openPracticeModal.bind(me)} className="btn btn-primary largeBtn soln no-float">{me.rb("scorecard.viewpracticereport")}</button>
								</div>
								</div>	
								);
							}
							else{
								if(isSolutionAvailable){
									return(
									<div className="clearfix col-12 row topbtnscontainer">
									<div className="col-12 text-center">
									<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln widthmax no-float" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.review_solution")}</button>
									</div>
									</div>
									);
								}else{
									return (<div></div>);
								}
							}
						}
						else{
							return (
							<div className="clearfix col-12 row topbtnscontainer">
							{(() =>{
								if(isSolutionAvailable){
									return (
									<div className="col-sm-12 col-md-6 col-12 text-center borderight">									
									<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln widthmax no-float" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.review_solution")}</button>
									</div>);
								}else{
									return (<div></div>);
								}
							})()}
							
							<div className={recommendedBtnStyleClass}>
							{(() => {
								let practiceBtnTxt = me.rb("scorecard.recommendationsnpractice");
								if (me.recommdata.testDetails && me.recommdata.lessonInfos && me.recommdata.lessonInfos.length > 0) {
									practiceBtnTxt = me.rb("scorecard.recommendationslessonpractice");
								} else if (me.recommdata.testDetails) {
									practiceBtnTxt = me.rb("scorecard.recommendationsnpractice");
								} else if (me.recommdata.minRelatedLessons && me.recommdata.minRelatedLessons.length > 0) {
									practiceBtnTxt = me.rb("scorecard.recommendationslesson");
								}
								return(
								<button type="button" onClick={me.showRecommendationScreen} className="btn btn-primary largeBtn soln widthmax no-float"  data-ga={"Post login - "+me.state.classDefnMap[me.state.data.testDetails.classId].className+" - Tests - "+me.state.data.breadcrumb.topicname+" - "+me.state.data.breadcrumb.subtopicname+" - "+(me.state.data.testDetails.mode == 1 ? "PT" : "CP")+" - "+"Scorecard - View Recommendations"}>{practiceBtnTxt}</button>
								);
							})()}
							</div>
							</div>
							)
						}
						

					}else{
						if(isSolutionAvailable){
							return(
							<div className="clearfix col-12 row topbtnscontainer">
							<div className="col-12 text-center">
							<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln widthmax no-float" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.review_solution")}</button>
							</div>
							</div>
							);
						}else{
							return (<div></div>);
						}
					}
				}else{
					if(isSolutionAvailable){
						return(
						<div className="clearfix col-12 row topbtnscontainer">
						<div className="col-12 text-center">
						<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln widthmax no-float" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.review_solution")}</button>
						</div>
						</div>
						);
					}else{
						return (<div></div>);
					}
				}
			} catch (e) {
				//console.error("Error occurred while parsing recommendations:", e);
				if(isSolutionAvailable){
					return(
						<div className="clearfix col-12 row topbtnscontainer">
						<div className="col-12 text-center">
						<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln widthmax no-float" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.review_solution")}</button>
						</div>
						</div>
						);
					}else{
						return (<div></div>);
					}			
				}
			}
			
			getRecommendView() {
				var recomStr = this.state.data.recommendResponseStr;
				var me = this;

				var recommendations = {};
				try {

					if (recomStr !== undefined && recomStr !== null && recomStr !== "null") {

						recommendations = JSON.parse(recomStr).recommendResponse;
						this.recommdata = recommendations;
						//console.log(this.recommdata);
				//process related lessons
				this.processRelatedLessons();
				if (typeof recommendations === "object" && Object.keys(recommendations).length > 0) {
					//console.log(this.recommdata.testDetails, Object.keys(this.recommdata.testDetails).length );
					//console.log(this.recommdata.minRelatedLessons, this.recommdata.minRelatedLessons.length );
					return (
						<Col className="col-sm-12 col-12 col-md-12 col-lg-4 viewrecobtn">
						<button type="button" onClick={this.showRecommendationScreen} className="btn btn-primary largeBtn soln"  data-ga={this.ViewRecommendationGA()}>
						{(() => {
							if (this.recommdata.testDetails && this.recommdata.lessonInfos) {
								return me.rb("scorecard.viewrecommendations");
							} else if (this.recommdata.testDetails) {
								return me.rb("scorecard.viewrecommendations");
							} else if (this.recommdata.minRelatedLessons && this.recommdata.minRelatedLessons.length > 0) {
								return me.rb("scorecard.viewrerelatedlessons");
							}
						})()}
						</button>
						</Col>
						)

				}
			}
		} catch (e) {
			console.error("Error occurred while parsing recommendations:", e);
		}
	}

	getFeedBackArea() {
		try {
			if(!this.props.match.params.reset){
				return (
					<Row className="recommandrow">
					<Col>
					<Row>
					<Col className="col-sm-12 col-12 col-md-12 col-lg-2 recommandcol">
					<span className="recommand"><img src={recommend} /></span>
					</Col>
					<Col className="col-sm-12 col-12 col-md-12 col-lg-6">
					<div className="reco_title">{this.rb("scorecard.recommendation_title")}</div>
					<span className="reco_desc">
					{(() => {
						return this.getFeedBackText();
					})()}
					</span>
					</Col>
					{this.getRecommendView()}
					</Row>
					</Col>
					
					
					</Row>
					);
			}
		} catch (e) {
			console.error(e);
		}
	}



	processRelatedLessons() {
		var minRelatedLessons = [];
		var tempRelationMap = {};

		try {
			var allRelatedLessons = this.recommdata.relatedLessons;
			var recommLessons = this.recommdata.lessonInfos;

			if (allRelatedLessons && typeof allRelatedLessons === "object" && allRelatedLessons.length > 0) {
				for (var l = 0; l < allRelatedLessons.length; l++) {
					tempRelationMap[allRelatedLessons[l].lessonUrl] = allRelatedLessons[l];
				}
			}

			if (recommLessons && typeof recommLessons === "object" && recommLessons.length > 0) {
				for (var r = 0; r < recommLessons.length; r++) {
					if (tempRelationMap[recommLessons[r].lessonUrl] !== undefined || tempRelationMap[recommLessons[r].lessonUrl] !== null) {
						delete tempRelationMap[recommLessons[r].lessonUrl];
					}
				}
			}
			minRelatedLessons = Object.values(tempRelationMap);
		} catch (e) {
			console.error(e);
		}

		this.recommdata.minRelatedLessons = minRelatedLessons;
	}

	imageSliderFn() {

	}
	openPracticeModal() {
		var me = this;
		if(this.recommdata && this.recommdata.testDetails){
			if (this.recommdata.testDetails.studentStatus && this.recommdata.testDetails.studentStatus == "COMPLETED") {
				let versionSuffix = this.props.match.params.reset && !isNaN(this.props.match.params.reset) ? ("/"+this.props.match.params.reset)  : "";
				window.location.href = "/scorecard/" + me.recommdata.testDetails.id + versionSuffix;
			} 
			else {
				setTimeout(function () {
				//	console.log("Custamized Test")
				me.showTestModal(me.recommdata.testDetails.id, me.state.data.testDetails.topicSubTopicMapId, me.state.data.testDetails.revisionTestId);
				me.fireMobileToast();
			}, 500);
			}
		}
		

	}

	showTestModal(testId, topicsubtopicId = null, revisiontestid = null) {
		this.setState({ testModalShow: true, testModalContent: this.setTestInfoScreen(testId, topicsubtopicId, revisiontestid), modalTitle: "", testModalView: "testInfo", modalLabel:""});
	}
	setTestInfoScreen(testId, topicsubtopicId, revisiontestid) {
		let TestInfoComp = this.getComponent("TestInfo");

		return <TestInfoComp callbackParent={this.startTest} testId={testId} topicsubtopicId={topicsubtopicId} revisiontestid={revisiontestid} onRef={ref => (this.getTestInfoComponent = ref)} gradeName={this.state.classDefnMap[this.state.data.testDetails.classId].className}/>
	}

	loadTestScreen(topicInfoObj, topicsubtopicId, revisiontestid) {
		return <GetTest topicInfoObj={topicInfoObj} topicsubtopicId={topicsubtopicId} revisiontestid={revisiontestid} onRef={ref => (this.getTestComponent = ref)} gradeName={this.state.classDefnMap[this.state.data.testDetails.classId].className} studentStatus={this.recommdata.testDetails.studentStatus}/>
	}

	onCloseHandler(){
		try{
			if(this.getTestComponent && typeof this.getTestComponent.onCloseHandler === "function"){
				this.getTestComponent.onCloseHandler();
			}else{
				console.warn("Not submitting this test: function 'onCloseHandler' not available");
			}					
		}catch(e){
			console.error(e);
		}
	}

	hideTestModal() {
		try {
			if (this.getTestComponent) {
				this.getTestComponent.modalCloseEvent();
			}else if(this.getTestInfoComponent){
				this.getTestInfoComponent.trackTestClose();
			}
		} catch (e) {}

		this.onCloseHandler();
		
		this.setState({ testModalShow: false, testModalContent: "loading", modalTitle: "", testModalView: "loading", modalLabel:"" });
		//this.getTopicList(subTopicView);		
		if (this.state.testModalView !== "staticContent") {
			this.setState({ dataLoaded: false });
			this.getScorecardData();
		}
		this.getAllSolutionsTrackingDetails();
	}
	
	hideRatingModal(){
		this.setState({ratingModalShow:false});
	}

	setModalClass() {
		if (this.state.testModalView == "testView") {
			return " modal-lg custom-modal";
		} else if (this.state.testModalView == "testInfo") {
			return " modal-lg info-modal";
		} else if (this.state.testModalView == "staticContent") {
			return " modal-lg solution-modal";
		}
		return " modal-lg";
	}
	setModalBackdropClose() {
		if (this.state.testModalView == "testView") {
			return "";
		} else if (this.state.testModalView == "testInfo") {
			return "";
		} else if (this.state.testModalView == "staticContent") {
			return this.hideTestModal;
		}
		return this.hideTestModal;
	}
	
	setModalTitle(topicInfoObj) {
		let testType = "";
		if (topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1") {
			testType = this.rb("home.proficiencytest");
		} else {
			testType = this.rb("home.customizepractice");
		}
		var topicname = topicInfoObj.testDetails.topics;
		topicname = topicname.split("- Customized Practice").join("");
		return topicname + " - " + testType;
	}

	setQModalTitle(topicInfoObj) {
		let testType = "";
		if (topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1") {
			testType = this.rb("scorecard.view_solution_proficiency");
		} else {
			testType = this.rb("scorecard.view_solution_customized");
		}
		var topicname = topicInfoObj.testDetails.topics;
		topicname = topicname.split("- Customized Practice").join("");
		return topicname + " - " + testType;
	}

	getReportName(topicInfoObj) {
		let testType = "";
		if (topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1") {
			testType = this.rb("scorecard.revision_test_report");
		} else {
			testType = this.rb("scorecard.revision_custom_report");
		}
		return testType;
	}

	getScorecardtitleName(topicInfoObj) {
		let testType = "";
		if (topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1") {
			testType = this.rb("scorecard.revision_test_report");
		} else {
			testType = this.rb("scorecard.revision_custom_report");
		}
		var topicname = topicInfoObj.testDetails.topics;
		topicname = topicname.split("- Customized Practice").join("");
		return testType + " - " + topicname;
	}

	loadModalContent() {
		if (this.state.testModalContent === "loading") {
			return (
				<div className="text-center loadingAnim">
				<Loader
				type="Oval"
				color="#00BFFF"
				height="100"
				width="100"
				/>
				</div>
				)
			} else {
				return (
				<div>
				{this.state.testModalContent}
				</div>
				)
			}

		}
		startTest(topicInfoObj, topicsubtopicId, revisiontestid) {
			this.setState({ testModalContent: this.loadTestScreen(topicInfoObj, topicsubtopicId, revisiontestid), modalTitle: this.setModalTitle(topicInfoObj), testModalView: "testView" });

			let source_test_id = "";
			let resumed = null;
			if (topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1") {
				source_test_id = "";
			} else {
				source_test_id = this.state.data.testDetails.id;
			}

			if (this.recommdata.testDetails.studentStatus == "NEW" || !this.recommdata.testDetails.studentStatus) {
				resumed = false;
			}
			else if (this.recommdata.testDetails.studentStatus == "IN_PROGRESS") {
				resumed = true;
			}
			var trackObj = {
				"subtopic_id" : topicsubtopicId,
				"test_id": topicInfoObj.testDetails.id,
				"source_test_id": source_test_id,
				"resumed": resumed
			}
			this.initiateTrack("test_started", trackObj);
		}
		getrecopracticelabel(){
			try{
				if (this.recommdata.testDetails.studentStatus === "COMPLETED") {
					return this.rb("home.btn.view");
				} else if (this.recommdata.testDetails.studentStatus === "IN_PROGRESS") {
					return this.rb("home.continue")+" Practice";
				}else {
					return this.rb("home.start")+" Practice";
				}
			}
			catch(e){
				return this.rb("home.start")+" Practice";
			}
		}

		lockcontent(){
			return(
			<span className="upgrdlock1"><i class="material-icons">lock</i></span>
			)
		}

		isPurchased(){
			return !this.state.recomLocked.practiceLocked;
		}

		isFreeTrail() {
			if(this.state.recomLocked.practiceLocked){
				return this.subscribeFn(this.ViewRecommendationGA()+" - Recommended Practice - Subscribe");
			}else{
				return(
				<button className="btn btn-primary largeBtn" onClick={this.openPracticeModal.bind(this)} data-ga={this.ViewRecommendationGA()+" - "+this.getrecopracticelabel()}>
				{(() => {
					if(this.recommdata && this.recommdata.testDetails && this.recommdata.testDetails.studentStatus){
						if (this.recommdata.testDetails.studentStatus === "COMPLETED") {
							return this.rb("home.btn.view");
						} else if (this.recommdata.testDetails.studentStatus === "IN_PROGRESS") {
							return this.rb("home.continue");
						} else {
							return this.rb("home.start");
						}
					}
					else{
						return this.rb("home.start");
					}
				})()}
				</button>
				)
			}
		}

		isFreeTrailSub(){
			if(this.state.recomLocked.practiceLocked){
				return this.subscribeFn(this.ViewRecommendationGA()+" - Recommended Lessons - Subscribe");
			}
		}

		renderRecomendationContent() {
			var me=this;
			this.trackRecommendationSolutionLoaded("recommendations");
			//console.log("recomlocked  :::",this.state.recomLocked,typeof this.state.recomLocked);
			
			return (
				<div className="recompage">
				{(() => {
					var classdisabled = "";	
					if(this.state.recomLocked.practiceLocked){
						classdisabled = "disabled lockdisabledrecom";
					}
					if (this.recommdata.testDetails) {
						return (
							<div>
							<div className="recomdiv">{this.rb("scorecard.recommended_practice")}</div>

							<Row className="allMiddle">
							<Col className="col-sm-12 col-12 col-md-3 col-lg-3 recommandcol">
							<img src={recomPracticeIcon} />
							</Col>
							<Col className="col-sm-12 col-12 col-md-6 col-lg-6">
							<div className="pr-15">{this.getFeedBackText2()}</div>
							</Col>
							<Col className="col-sm-12 col-12 col-md-3 col-lg-3 text-center">
							{this.isFreeTrail()}
							</Col>
							</Row>


							<hr />
							</div>

							)
						}
					})()}


					{(() => {
						if (this.recommdata.lessonInfos && this.recommdata.lessonInfos.length > 0) {
							return (
							<div>
							<div className="recomdiv">{this.rb("scorecard.recommended_lessons")}</div>

							<Row className="allMiddle">
							<Col className="col-sm-12 col-12 col-md-3 col-lg-3 recommandcol">
							<img src={recomLessonIcon} />
							</Col>
							<Col className="col-sm-12 col-12 col-md-9 col-lg-9">
							<div>{this.rb("scorecard.recommended.rawtext2")}</div>
							</Col>
							{/* <Col className="col-sm-12 col-12 col-md-3 col-lg-3 text-center">
							{this.isFreeTrail()}
						</Col> */}
						</Row>

						<Row className="allMiddle">

						<Col className="col-sm-8 col-8 col-md-10 col-lg-10 imgGal">
						<div className="co-12 text-center scorecardLessons">

					{/*<Swiper className="student-slider" navigation={params.navigation} slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween}>*/}
					<Slider {...settings}>
					{this.recommdata.lessonInfos.map((lesson, index) =>
						<div {...this.props} key={index} data-index={index}  data-ga={this.ViewRecommendationGA()+" - Lessons"}><LessonComponent isFrom={"ViewSoln"} isFreeTrail={this.state.data.recommendedLessonLocked} lesson={lesson} testId={this.testId} topicSubTopicMapId={this.state.data.testDetails.topicSubTopicMapId} accessId={this.state.data.testDetails.accessId} classId={this.state.data.testDetails.classId} tracksource="recommended_lessons" /></div>
						)}

						</Slider>
					{/*</Swiper>*/}

					<div className="col-12 text-center allMiddle"> 		
					{this.isFreeTrailSub()}
					</div>
					</div>

					
					</Col>

					</Row>

					<hr />
					</div>

					)
				}
			})()}


			{(() => {
				if (this.recommdata.minRelatedLessons !== undefined && this.recommdata.minRelatedLessons !== null && this.recommdata.minRelatedLessons.length > 0) {
					return (
					<div>
					<div className="recomdiv">{this.rb("scorecard.related_lessons")}</div>

					<Row className="allMiddle">

					<Col className="col-sm-12 col-12 col-md-3 col-lg-3 recommandcol">
					<img src={recomRelatedLessonIcon} />
					</Col>
					<Col className="col-sm-12 col-12 col-md-9 col-lg-9">
					<div>{this.rb("scorecard.recommended.rawtext3")}</div>
					</Col>
					</Row>

					<Row className="allMiddle">

					<Col className="col-sm-8 col-8 col-md-10 col-lg-10 imgGal">
					<div className="co-12 text-center scorecardLessons">
					{/*<Swiper className="student-slider" navigation={params.navigation} slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween}>
					{this.recommdata.minRelatedLessons.map((lesson,index) =>
						<LessonComponent lesson={lesson} testId={this.testId} topicSubTopicMapId={this.state.data.testDetails.topicSubTopicMapId} key={index} />
						)}
					</Swiper>*/}
					<Slider {...settings}>
					{this.recommdata.minRelatedLessons.map((lesson, index) =>
						<div {...this.props} key={index} data-index={index}><LessonComponent isFrom={"Scorecard"} lesson={lesson} testId={this.testId} topicSubTopicMapId={this.state.data.testDetails.topicSubTopicMapId} isFreeTrail={this.state.data.recommendedLessonLocked} accessId={this.state.data.testDetails.accessId} classId={this.state.data.testDetails.classId} tracksource="related_lessons" key={index} /></div>
						)}

						</Slider>

						</div>
						<div className="col-12 text-center allMiddle"> 		
						{this.isFreeTrailSub()}
						</div>
						</Col>

						</Row>
						</div>

						)
					}
				})()}

				</div >
				)
}

piechartFn() {
		const piedata = [this.getCorrectCount(), this.getIncorrectCount(), this.getUnAttemptedCount()]; //how many partitions you want
		const piecolors = ["#2daa13", "#ff6d00", "#d1d3d4"]; //partiation color
		const pieindata = [this.getCorrectCount(), "/", this.getQuestionCount()];  //inside data of svg
		//console.log(piedata + " " + piecolors+" "+pieindata);

		return (
			<div className="piechart">
			<PiechartComp
			data={piedata}
			colors={piecolors}
			txtval={pieindata} />
			</div>
			)

		}

		trackScorecardLoaded() {
			var endTime = new Date().getTime();
			var loadedTime = -1;
			if (scorecardLoadedTime != null) {
				loadedTime = endTime - scorecardLoadedTime;
			}



			var trackObj = {
				"source_id": this.testId,
				"load_duration": loadedTime,
				"page_type": this.getTracker().enums.loadedPageType.scorecard
			}
			this.initiateTrack("page_loaded", trackObj);

			scorecardLoadedTime = null;
		}
		trackRecommendationSolutionLoaded(recommendations) {
			var trackObj = {
				"source_id": this.testId,
				"load_duration": 0,
				"page_type": this.getTracker().enums.loadedPageType[recommendations]
			}
			this.initiateTrack("page_loaded", trackObj);
		}

		getRecommendPracticeTitle() {
			if (this.recommdata.testDetails) {
				return this.recommdata.testDetails.topics;
			}
		}
		getSelectedEmojiIcon(){	 console.log("render...:",this.state.selectedEmoji);
		switch(this.state.selectedEmoji) {
			case 5:		    	
			return ( <img className="shakeme" src={ratingLoveitIconSmall} /> );
			break;
			case 4:
			return ( <img className="shakeme" src={ratingGoodIconSmall} /> );
			break;
			case 3:
			return ( <img className="shakeme" src={ratingNormalIconSmall} /> );
			break;
			case 2:
			return ( <img className="shakeme" src={ratingBadIconSmall} /> );
			break;
			case 1:
			return ( <img className="shakeme" src={ratingVerybadIconSmall} /> );
			break;
			default:
			return ( <img src={ratingDefaultIcon} /> );
		}
	}
	saveRating(){
		var me = this;
		var ratingData = {
			"topicId" : this.state.data.breadcrumb.topicid,
			"subTopicId" : this.state.data.breadcrumb.subtopicid,
			"classId" : parseInt(this.state.data.testDetails.classId),
			"accessId" :parseInt(this.state.data.testDetails.accessId),
			"rating" : parseInt(this.selectedRate)
		}
		
		var callBackSuccess = function(response){
			console.log("response:::",response);
		}

		var callBackFailure = function(error){
			console.log("Error in Ssubtopic RATING_EMOJI_SAVE");
		}

		new HmAjax(this.getUrlFor("RATING_EMOJI_SAVE"),ratingData).post(callBackSuccess,callBackFailure);	
		
		//----------------
		//console.log("scorecardrating id:::",this.state.data.breadcrumb);
		try{
			var trackObj = {
				"subtopic_id": this.state.data.breadcrumb.topicsubtopicmapid,
				"rating": parseInt(this.selectedRate),
				"grade_id": parseInt(this.state.data.testDetails.classId),
				"product_type": parseInt(this.state.data.testDetails.accessId),
				"source": this.getTracker().enums.itemRatedSource.scorecard
			}			
			
			this.initiateTrack("item_rated",trackObj);
		}catch(e){}
	}
	selectRating(event){
		var target = event.currentTarget;
		$(".emojiicons").removeClass("selected");
		$(target).addClass("selected");
		this.selectedRate = $(target).attr("data-rateindex");
		this.setState({selectedEmoji:parseInt($(target).attr("data-rateindex"))});
		this.saveRating();
		
		if(this.state.ratingModalShow){
			this.hideRatingModal();
		}else{
			this.toggle();
		}
	}
  /*toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
}*/
toggle() {
	var me = this;
	if(this.state.popoverOpen == false){
		me.setState({
			popoverOpen: !me.state.popoverOpen
		});
	}else{
		me.setState({
			popoverOpen: !me.state.popoverOpen
		});
	}
	
}
getcloselabel(){
	return this.state.modalLabel+" - Close";
}

renderPracticeReportButton(){
	if(this.props.match.params.reset){
		var recommendations = {};
		var recomStr = this.state.data.recommendResponseStr;
		if (recomStr !== undefined && recomStr !== null && recomStr !== "null") {
			var recommendations = JSON.parse(recomStr).recommendResponse;
			this.recommdata = recommendations;
			
			if (this.recommdata.testDetails && this.recommdata.testDetails.studentStatus == "COMPLETED") {
				return(
					<button type="button" onClick={this.openPracticeModal.bind(this)} className="btn btn-primary largeBtn soln">{this.rb("scorecard.viewpracticereport")}</button>
					);
				}
			}
		}
	}
	
	renderScoreData() {
		if (this.state.dataLoaded && this.state.classDefnMap) {
			this.processFeedBackText();
			this.calculateQuestionCount();
			return (
			<div id="scrbread">
			<div className="breadcrumb-holder">
			<ul className="breadcrumb">
			<li className="breadcrumb-item active">{this.state.data.breadcrumb.topicname}</li>
			<li className="breadcrumb-item active">{this.state.data.breadcrumb.subtopicname}</li>
			<li className="breadcrumb-item active">{this.getReportName(this.state.data)}</li>

			</ul>
			</div>
			
			
			{this.getRecommendViewOnTop()}
			

			<div className="scoretitle clearfix">
			<span className="pull-left">{this.getScorecardtitleName(this.state.data)} </span>
			<span className="pull-right">
			<div className="pr-15">
			<div className="ratingemoji" onClick={this.toggle} id={'Popover-' + this.state.data.testDetails.topicSubTopicMapId}>
			{this.getSelectedEmojiIcon()}
			</div>
			<Popover className="emojiPopover scorecard" placement='right-start' isOpen={this.state.popoverOpen} target={'Popover-' + this.state.data.testDetails.topicSubTopicMapId} toggle={this.toggle}>
		{/*<PopoverHeader>Popover Title</PopoverHeader>*/}
		<PopoverBody className="pos_relative">	
		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={5} src={ratingLoveitIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Loved it</div></div>
		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={4} src={ratingGoodIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Good</div></div>
		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={3} src={ratingNormalIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Normal</div></div>
		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={2} src={ratingBadIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Hard</div></div>
		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={1} src={ratingVerybadIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Very hard</div></div>						          		
		</PopoverBody>
		</Popover>
		</div>
		</span>
		</div>

		<Row className="">
		<Col sm={12} xs={12} md={6} lg={3} className="noleftpadding">
		<div className="score-inner">
		<div className="box1">
		</div>
		<Row className="box1Row">
		<Col sm={6} xs={6} md={6} lg={6}>
		<span className="scard">
		<img src={scardgicon} /></span>
		</Col>
		<Col sm={6} xs={6} md={6} lg={6} className="nopadding text-left">
		<div className="boxtxt"> {this.rb("scorecard.grade")} </div>
		<div className="reward">
		{this.getUserGrade()}
		</div>
		</Col>
		</Row>
		</div>
		</Col>

		<Col sm={12} xs={12} md={6} lg={4} className="noleftpadding">
		<div className="score-inner">
		<div className="box2">
		</div>
		<Row className="box2Row">
		<Col sm={6} xs={6} md={6} lg={6}>
		<span className="scard">
		<img src={scardpicon} /></span>
		</Col>
		<Col sm={6} xs={6} md={6} lg={6} className="nopadding">
		<span className="boxtxt"> {this.rb("scorecard.points")} </span><br />
		<div className="score">
		{this.getUserPoints()}
		</div>
		<div className="scoreoutof">{this.rb("scorecard.out_of")} {this.getTotalPoints()}</div>
		</Col>
		</Row>
		</div>
		</Col>

		<Col sm={12} xs={12} md={12} lg={5} className="noleftpadding">
		<div className="score-inner">
		<div className="box3">
		</div>
		<Row>
	{/* {Piechart report} */}
	<Col sm={5} xs={5} md={5} lg={5}>
	{this.piechartFn()}
	</Col>

{/* {Result card} */}

<Col sm={7} xs={7} md={7} lg={7} className="pt-20">
<Table className="result">
<tbody>
<tr>
<td className="nosidepaddingmust"><span><i className="material-icons resultalg rightans">done</i></span><span className="boxtxt">{this.rb("scorecard.correct")}</span></td>
<td className="nosidepaddingmust">{this.getCorrectCount()}</td>
</tr>
<tr>
<td className="nosidepaddingmust"><span><i className="material-icons resultalg wrongans">close</i></span><span className="boxtxt">{this.rb("scorecard.incorrect")}</span></td>
<td className="nosidepaddingmust">{this.getIncorrectCount()}</td>
</tr>
{this.unanswerdata(this.state.data)}
</tbody>
</Table>
</Col>

</Row>
</div>
</Col>

</Row>

<br />
{this.getSummaryView()}

<br />
{/*<Row className="solnrow">
<Col className="solncontainer">
<button type="button" onClick={this.showViewSolutionScreen.bind(this)} className="btn btn-primary largeBtn soln" data-ga={this.ViewsolutionGA()}>{this.rb("scorecard.view_solution")}</button>
</Col>
</Row>
<br />
{this.getFeedBackArea()}
*/}
<div>
<TestTakingModalComponent visible={this.state.testModalShow} dialogClassName={this.setModalClass()} onClickBackdrop={this.setModalBackdropClose()}>
<div className="modal-header bg-purple">
<div className="modal-title">
{this.state.modalTitle}
</div>
<div className="close" onClick={this.hideTestModal} aria-label="Close" data-ga={"Post login - "+this.state.classDefnMap[this.state.data.testDetails.classId].className+" - Tests - "+this.state.data.breadcrumb.topicname+" - "+this.state.data.breadcrumb.subtopicname+" - "+(this.state.data.testDetails.mode == 1 ? "PT" : "CP")+" - "+"Scorecard - "+this.getcloselabel()}>
<span aria-hidden="true"><i className="material-icons">close</i></span>
</div>
</div>
<div className="modal-body testModalBody">
{this.loadModalContent()}
</div>
</TestTakingModalComponent>
</div>

<div>
<TestTakingModalComponent visible={this.state.ratingModalShow} dialogClassName={"ratingModal"} onClickBackdrop={this.hideRatingModal}>
<div className="modal-header rating-mdl-header">
<div className="modal-title">
{this.rb("scorecard.rating.headermsg")}
</div>
<div className="skipmodal" onClick={this.hideRatingModal} aria-label="Close">
<span aria-hidden="true">Skip</span>
</div>
</div>
<div className="modal-body">
<div className="pos_relative text-center ratingbody">	
<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={5} src={ratingLoveitIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Loved it</div></div>
<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={4} src={ratingGoodIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Good</div></div>
<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={3} src={ratingNormalIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Normal</div></div>
<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={2} src={ratingBadIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Hard</div></div>
<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={1} src={ratingVerybadIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Very hard</div></div>						          		
</div>
</div>
</TestTakingModalComponent>
</div>

<Navtop />

</div>
);
} else {
	return (<div> {this.showLoader()}</div>);
}
}

render() {

	return super.render(
	(<div className="scorecardComponent" data-p-ga="">

	{this.renderScoreData()}
	</div>),false
	);
}
} 


// WEBPACK FOOTER //
// ./src/views/scorecard/Scorecard.js